import IndexModel from "@/service/v1/elastic/IndexModel";

/*
 * Logs da aplicação gravados no OpenSearch pelo sink do Serilog.
 *
 * Quem escreve é o sink, por isso aqui não há criar índice nem sincronizar como
 * nos demais serviços. O createIndex/deleteIndex herdados do IndexModel também
 * não servem: eles miram um índice sem o curinga, e os índices reais do Serilog
 * são diários. A exclusão aqui é por documento ou por data de corte.
 */
class LogSerilogElasticService extends IndexModel {

    constructor() {
        super();
        this.url = this.url + '/LogSerilogElastic';
    }

    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    public excluir( id: any ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().delete( this.url + '/' + id )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }

    /*
     * Expurgo: apaga todos os logs anteriores à data de corte e devolve
     * { excluidos: n }. A data vai como veio do input datetime-local
     * ("2026-10-07T14:30"), formato que o DateTime do .NET aceita direto.
     */
    public excluirAnteriores( data: any ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().delete( this.url + `/Anteriores?data=${encodeURIComponent(data)}` )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }

}

export default LogSerilogElasticService;
